import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from './header-search-bar-suggestions-container.module.scss';

export const HeaderSearchBarSuggestionsContainer: FC<PropsWithChildren> = ({
  children
}) => (
  <div
    className={cx(`${styles['header-search-bar-suggestions-container']} p-3`)}
    data-testid="redesigned-suggestion-list"
  >
    {children}
  </div>
);
